// @flow
import { handleActions } from 'redux-actions'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { sort } from './utils'

//
import { ACTION_PREFIX } from './consts'

//import { reducers as productReducers } from './product/reducers'
//import { reducers as sampleReducers } from './sample/reducers'
//import { reducers as moodboardReducers } from './moodboard/reducers'

export const initState = {
  init: false,
  entries: {
    data: [],
    total: false,
    isLoading: false,
  },
  entry: {
    data: null,
    error: null,
    isLoading: false,
  },
  active: null,
  permissions: {},
}

/**
 * Root reducer
 */
export const reducers = () => ({
  project: handleActions(
    {
      INIT: {
        REQUEST: (state, action) => ({
          ...state,
        }),
        SUCCESS: (state, action) => ({
          ...state,
          init: true,
        }),
      },
      SET_ACTIVE: (state, action) => ({
        ...state,
        active: action.payload.id,
      }),
      SET_PERMISSIONS: (state, action) => ({
        ...state,
        permissions: action.payload.permissions,
      }),
      CLEAR_ENTRIES: (state, action) => ({
        ...state,
        entries: initState.entries,
      }),
      LOAD_ENTRIES: {
        REQUEST: (state, action) => ({
          ...state,
          entries: {
            isLoading: true,
            data: [],
            total: false,
          },
        }),
        SUCCESS: (state, action) => ({
          ...state,
          entries: {
            isLoaded: true,
            isLoading: false,
            data: [...action.payload.entries],
            total: action.payload.total,
          },
        }),
      },
      LOAD_ENTRY: {
        REQUEST: (state, action) => ({
          ...state,
          entry: {
            data: null,
            error: null,
            isLoading: true,
          },
        }),
        FAILURE: (state, action) => ({
          ...state,
          entry: {
            data: null,
            error: action.payload,
            isLoading: false,
          },
        }),
        SUCCESS: (state, action) => ({
          ...state,
          entry: {
            data: action.payload.data,
            error: null,
            isLoading: false,
          },
        }),
      },
      ADD_ENTRY: {
        SUCCESS: (state, action) => ({
          ...state,
          entry: action.payload.registratedEntry,
        }),
      },
      UPDATE_ENTRY: {
        SUCCESS: (state, action) => ({
          ...state,
          entry: {
            data: action.payload.updated,
            error: null,
            isLoading: false,
          },
        }),
      },
      REMOVE_ENTRY: {
        SUCCESS: (state, action) => ({
          ...state,
          entries: initState.entries,
        }),
      },
    },
    initState,
    {
      prefix: ACTION_PREFIX,
    },
  ),
})
